import { BadgeCheck } from "lucide-react";

export const VerifiedTick = ({ ok, label = "Mobile verified", testid = "mobile-verified-badge" }) => ok ? (
  <span className="inline-flex items-center gap-1 rounded-full bg-[#E7F6EE] px-2 py-0.5 text-xs font-bold text-[#1F7A50]" data-testid={testid}>
    <BadgeCheck className="h-4 w-4" />{label}</span>
) : null;
